<template>
  <div class="content-inner">
    <div class="col-12">
      <div class="row">
        <div
          class="col-12 text-center"
          style="line-height: 3em"
          v-if="questionnairesData"
        >
          <h6>{{ questionnairesData.name }}</h6>
          <span>{{ getFormattedDate(questionnairesData.updatedAt) }}</span>
        </div>
      </div>
      <form-renderer
        :schema="selectedQuestionnaireJson"
        model
        style="margin-top: 2em"
        :read-only="true"
        v-if="selectedQuestionnaireJson"
      ></form-renderer>
    </div>
  </div>
</template>

<script>
import FormRenderer from "src/pages/carenation/components/FormRenderer.vue";
import moment from "moment";

export default {
  name: "questionnaire",

  components: {
    FormRenderer,
  },

  async mounted() {
    let answeredAuestionnaire = await this.$store.dispatch(
      "getAnsweredQuestionnaire",
      this.$route.params.questionnaireAnswerId
    );
    this.selectedQuestionnaire = answeredAuestionnaire.answer;
  },

  data() {
    return {
      selectedQuestionnaire: null,
    };
  },

  computed: {
    questionnairesData() {
      return this.$store.state.questionnaire;
    },
    selectedQuestionnaireJson() {
      return JSON.parse(this.selectedQuestionnaire);
    },
  },

  methods: {
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped>
/deep/ .el-select.questionnaire-select .el-input .el-input__inner {
  margin-top: 0px;
}
/deep/ .el-select.questionnaire-select {
  width: 100%;
}
/deep/ .el-select.questionnaire-select .el-input__suffix {
  top: -4px;
}
</style>
